import { render, staticRenderFns } from "./areaDispose.vue?vue&type=template&id=23089844&scoped=true&"
import script from "./areaDispose.vue?vue&type=script&lang=js&"
export * from "./areaDispose.vue?vue&type=script&lang=js&"
import style0 from "./areaDispose.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./areaDispose.vue?vue&type=style&index=1&id=23089844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23089844",
  null
  
)

export default component.exports